import $ from 'jquery';
import { runProtectedRoute } from '../middleware';
import { dispalySubscritionDetails } from '~src/user';
import { checkOrgStatus, showNavbarPrivateBackButton } from '~src/utils';
import { getUser } from '~src/user';
import { initOpenStripeCustomerPortalListeners } from '~src/stripeCustomerPortal';
import { trackPageView } from '~src/tracking';

export const subscriptionRoute = async () => {
  document.title = 'Abbonamento | Giotto';

  const ready = await runProtectedRoute({ accessStatusPage: true });
  if (!ready) return;

  showNavbarPrivateBackButton();
  const { user } = await getUser();

  const org = user.org_pointer;

  $('#subscrition-expired, #subscrition-new, #subscrition-detail').hide();
  if (!(await checkOrgStatus({ redirect: false }))) {
    $('#subscrition-expired').show();
  } else if (org.tipo_istanza === 'demo') {
    $('#subscrition-new').show();
  } else {
    $('#subscrition-detail').show();
    await dispalySubscritionDetails(org);
  }

  initOpenStripeCustomerPortalListeners();
  $('#route-plan').show();
  trackPageView('Subscription');
};
